import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { margins } from "style";
import DisplayBox from "components/DisplayBox";

/**
 * AiSummaryContainer - Container component for AI summaries
 * Wraps content with DisplayBox structure for consistent layout
 *
 * @param {String|Element}  title           Title for the display box
 * @param {Boolean}         loading         Loading state
 * @param {Object}          data            Data to display (can be string or object)
 * @param {Object}          error           Error object if any
 * @param {String}          emptyMessageId  Intl message ID for empty state
 * @param {Function}        itemRenderer    Function to render items
 * @param {Boolean}         hideHeader      Whether to hide the header
 * @param {String}          marginSize      Margin size for the container
 */
const AiSummaryContainer = ({
  title,
  loading,
  data,
  error,
  emptyMessageId = "AISummary.NoSummary",
  itemRenderer,
  hideHeader = false,
  marginSize = margins.normal,
  ...props
}) => {
  // Convert data to array format expected by DisplayBox
  const displayData = data ? [{ title: null, body: data }] : [];

  return (
    <DisplayBox
      title={title}
      numColumns={1}
      loading={loading}
      itemRenderer={itemRenderer}
      error={error}
      emptyMsg={<FormattedMessage id={emptyMessageId} />}
      isEmpty={!loading && !data}
      marginSize={marginSize}
      hideHeader={hideHeader}
      data={displayData}
      {...props}
    />
  );
};

AiSummaryContainer.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  loading: PropTypes.bool,
  data: PropTypes.any,
  error: PropTypes.object,
  emptyMessageId: PropTypes.string,
  itemRenderer: PropTypes.func,
  hideHeader: PropTypes.bool,
  marginSize: PropTypes.string,
};

export default AiSummaryContainer;
